import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 微信回调相关枚举
 */
/**
 * 信息类型
 */
class InfoType extends UltMeta {
    SUITE_TICKET = new Meta("suite_ticket", "推送 suite_ticket");
    CREATE_AUTH = new Meta("create_auth", "授权成功通知");
    CHANGE_AUTH = new Meta("change_auth", "变更授权通知");
    CANCEL_AUTH = new Meta("cancel_auth", "取消授权通知");
}

export const INFO_TYPE = new InfoType();

class Status extends UltMeta {
    ACTIVE = new Meta("1", "已激活");
    DISABLED = new Meta("2", "已禁用");
    UNACTIVE = new Meta("4", "未激活 已激活代表已激活企业微信或已关注微工作台（原企业号）");
    CANCEL = new Meta("5", "成员退出");
}
export const STATUS = new Status();
